import store from '../store/index';
import { getUrlQueryParam, getAllUrlQueryParam, skipMissingInfoPage } from '@/utils/helper';
import Constants from '@/utils/constants';
import { decodeConferenceDetails } from '@/utils/helper';
import moment from 'moment';
import {  getSGMMeetingJoinLink, getPresentationRouteUrl } from '@/service/api';

export function getUserDetails() {
  return store.getters['login/POST_CONFIRM_EMAIL'];
}

export function getUserEmailAddress() {
  return store.getters['login/GET_USER_EMAIL_ADDRESS'];
}

export async function getRedirectBasedOnConferenceCallExists(showId, confId) {
  if (showId) {
    try {
      await getConferenceCallAndBrandingInfo(showId, confId);
      if (getConferenceData().Status === Constants.ConferenceStatus.Expired) {
        const uniqueId = store.getters['conferenceCall/GET_UNIQUE_ID'];
        if(uniqueId) {
          return {
            name: 'conference-ended-new',
            params: { uniqueId }
          };
        }
        if(isSlidePlusConfShow()) {
          if(moment().isAfter(moment.utc(getConferenceData().EntryCodeEndTimeUtc).local())) {
            if(confId){
              return `/conference-ended?show=${showId}&confId=${confId}`;
            }
            return `/conference-ended?show=${showId}`;
          }
        } else {
          if(confId){
            return `/conference-ended?show=${showId}&confId=${confId}`;
          }
          return `/conference-ended?show=${showId}`;
        }
      }
      // Redirecting if the call is SGM Operator Assisted
      if (isSGMOperatorAssisted()) {
        await store.dispatch('login/getLoggedInUserDetailsWithoutRedirectOnError');
        try{
          await redirectToZoom(showId);
        }catch(err){
          store.dispatch('service/set_loader', false);
          if(err.response.status === 422 && err.response.data.Error === "Meeting has ended."){
            return `/meeting-ended`;
          }
          else if(err.response.status === 422){
          store.dispatch('global/setShowMGMjoinLinkErrorModal',err.response.data)
          }
        }
        return false;
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        if (isSGMOperatorAssisted() && showId === 'undefined') {
          return false;
        }
        return `/404-not-found`;
      } else {
        return `/site-not-available`;
      }
    }
  } else {
    return `/404-not-found`;
  }
};

export async function getConferenceParamsFromToken(uniqueId) {
  if (!uniqueId) return {};

  try {
    // If all required values exist in state, return them
    const state = store.state.conferenceCall;
    if (state.showId && state.confId && state.isListenOnly !== undefined && state.uniqueId) {
      return {
        uniqueId: state.uniqueId,
        show: state.showId,
        confId: state.confId,
        listenOnly: state.isListenOnly
      };
    }

    // Decode and validate token
    store.commit('conferenceCall/SET_UNIQUE_ID', uniqueId);
    const conferenceQueryParamString = await decodeConferenceDetails(uniqueId);
    if (!conferenceQueryParamString) {
      throw new Error('Invalid conference token');
    }

    const params = new URLSearchParams(conferenceQueryParamString);
    const showId = params.get('show');
    const confId = params.get('confId');
    const isListenOnly = params.get('listenOnly') === 'true';

    // Batch store updates
    store.commit('conferenceCall/SET_CONFERENCE_PARAMS', {
      showId,
      confId,
      isListenOnly
    });

    return {
      uniqueId,
      show: showId,
      confId,
      listenOnly: isListenOnly
    };
  } catch (error) {
    console.error('Error processing conference token:', error);
    return {};
  }
}

async function getConferenceCallAndBrandingInfo(showId, confId) {
  // return if conference data is present in store
  if (Object.keys(getConferenceData()).length) {
    return;
  }

  try {
    await store.dispatch('conferenceCall/fetchConferenceCallDetails', { showLink: showId, confId: confId });
    const { PresId, BrandingGroupGuid, ConferenceBrandingGroupId } = getConferenceData();
    await store.dispatch('corporateBranding/getEventBranding', BrandingGroupGuid);
    await store.dispatch('corporateBranding/getEventBrandingInfo', ConferenceBrandingGroupId);
    await store.dispatch('corporateBranding/getEventBrandingLogos', PresId);
  } catch (err) {
    throw err;
  }
}

/**
 * Method will handle on browser reload, it will make the api calls for conference details
 * and presentation details.
 */
export async function onRouteInitialize() {
  const uniqueId = store.getters['conferenceCall/GET_UNIQUE_ID'];
  const showId = uniqueId ? store.state.conferenceCall.showId : getUrlQueryParam();
  const confId = uniqueId ? store.state.conferenceCall.confId : getAllUrlQueryParam('confId');
  if (!Object.keys(getConferenceData()).length) {
    try {
      await store.dispatch('conferenceCall/fetchConferenceCallDetails', { showLink: showId, confId: confId });
      const { PresId, BrandingGroupGuid, ConferenceBrandingGroupId } = getConferenceData();
      await store.dispatch('corporateBranding/getEventBranding', BrandingGroupGuid);
      await store.dispatch('corporateBranding/getEventBrandingInfo', ConferenceBrandingGroupId);
      await store.dispatch('corporateBranding/getEventBrandingLogos', PresId);
    }catch (error) {
      if (error.response && error.response.status === 404) {
        return `/404-not-found`;
      } else {
        return `/site-not-available`;
      }
    }
  }

  if (!Object.keys(getEntryCodeData()).length) {
    await store.dispatch('presentation/fetchPasswordDetails', showId);
  }
  
  var logId = store.getters['presentation/GET_LOG_ID'];
  var email = getUserEmailAddress();
  if (email === "") {
    email = getAllUrlQueryParam('email');
    if (uniqueId) {
      location.replace('/events/login/' + uniqueId + '?email=' + email);
    } else {
      if (confId) {
        location.replace('/events/login?show=' + showId + '&confId=' + confId + '&email=' + email);
      }
      else {
        location.replace('/events/login?show=' + showId);
      }
    }
  } else if(!logId) {
    const { Id, RequireVerification } = getConferenceData();
    const statusParams = {
      email : email,
      EntryCode : getEntryCodeData().ShowPassword,
      confid : confId || Id,
      suppressConfEmail: !RequireVerification,
      ListenOnly: store.getters['conferenceCall/GET_IS_LISTEN_ONLY']
    }
    await store.dispatch('login/protectedFetchUserRegistrationStatus', statusParams);
  }

  if (!Object.keys(getLoggedInUser()).length) {
    await store.dispatch('login/getLoggedInUserDetails');
  }

  if (!isSGMType() && !Object.keys(getRegisteredUserForCall()).length) {
    await store.dispatch('conferenceCall/getRegisteredUserForCall');
  }

  if (!Object.keys(getDisclaimerData()).length) {
    await store.dispatch('presentation/fetchDisclaimers');
  }
}

export async function getRedirectBasedOnEmailConfirmed(rowGuid, showId, confId) {
  if (showId && rowGuid) {
    await store.dispatch('login/confirmUserEmail', rowGuid);
    const userDetails = getUserDetails();
    if (userDetails) {
      await store.dispatch('login/fetchMissingInformationStatus', getUserEmailAddress());
      return handleRedirection();
    } else {
      const uniqueId = store.getters['conferenceCall/GET_UNIQUE_ID'];
      if (uniqueId) {
        return {
          name: 'login-new',
          params: { uniqueId }
        };
      }
      if (confId) {
        return `/login?show=${showId}&confId=${confId}`;
      }
      return `/login?show=${showId}`;
    }
  }
};

export async function getRedirectBasedOnAccountConfirmed(rowGuid) {
  if (rowGuid) {
    await store.dispatch('login/confirmUserEmail', rowGuid);
    const userDetails = getUserDetails();
    if (userDetails) {
      return `/404-not-found`;
    }
  }
};

export async function getGlobalNumberBasedOnRouteQuery(confId, presId, sgmMeetingId) {
  if (presId && sgmMeetingId) {
    const params = {presId: presId, meetingId: sgmMeetingId}
    await store.dispatch('globalNumbers/fetchGlobalNumbersSGM', params);
  }
  else if (presId && !sgmMeetingId) {
    try {
      const params = {presId: presId}
      await store.dispatch('globalNumbers/fetchGlobalNumbersMGM', params);
    } catch(e) {
      return `/404-not-found`;
    }
  } else {
    await store.dispatch('globalNumbers/fetchGlobalNumbers', confId);
  }
}

function getBrandingInfo(){
  return store.getters['corporateBranding/getBrandingInfo'];
}

function getConferenceData() {
  return store.getters['conferenceCall/GET_CONFERENCE_CALL_DETAILS'];
}

function getDisclaimerData() {
  return store.getters['presentation/GET_DISCLAIMERS'];
}

function getEntryCodeData() {
  return store.getters['presentation/GET_PASSWORD_DETAILS'];
}

function getParticipantAccessRevoked() {
  return store.getters['conferenceCall/GET_PARTICIPANT_ACCESS_REVOKED'];
}

function getPublicParticipantAccessRevoked() {
  return store.getters['conferenceCall/GET_PUBLIC_PARTICIPANT_ACCESS_REVOKED'];
}

function getLoggedInUser() {
  return store.getters['login/GET_LOGGED_IN_USER'];
}

function getRegisteredUserForCall() {
  return store.getters['conferenceCall/GET_REGISTERED_USER_FOR_CALL'];
}

function getMissingInfoStatus() {
  return store.getters['login/GET_MISSING_INFO_STATUS']
}

function isSimuLiveVideo() {
  const { HasSimuLiveVideo } = getConferenceData();
  return HasSimuLiveVideo;
}

function isUserPresenter() {
  return store.getters['login/GET_IS_USER_PRESENTER'];
}

export function isConfOnlyShow() {
  return store.getters['conferenceCall/GET_IS_CONF_ONLY_SHOW'];
}

export function isSlidePlusConfShow() {
  return store.getters['conferenceCall/GET_IS_SLIDE_CONF_SHOW'];
}

export function isSlidePlusLiveVideo() {
  return store.getters['conferenceCall/GET_IS_SLIDE_LIVE_VIDEO'];
}

export function isEventViewerEnabled() {
  return store.getters['conferenceCall/GET_IS_EVENT_VIEWER_ENABLED'];
}

export function isSGMType() {
  return store.getters['conferenceCall/GET_IS_SMALL_GROUP_MEETING_TYPE'];
}

export function isSGM() {
  return store.getters['conferenceCall/GET_IS_SMALL_GROUP_MEETING'];
}

export function isSGMOperatorAssisted() {
  return store.getters['conferenceCall/GET_IS_SMALL_GROUP_MEETING_OPERATOR_ASSISTED'];
}


  /**
   * Check whether the user has registered before and
   * redirect to the appropriate page.
   */
async function getRedirectionResult(confId, showId) {
  const { IsRegistered } = getRegisteredUserForCall();
  const isShowSGMType = isSGMType();
  const isShowSGM = isSGM();
  const uniqueId = store.getters['conferenceCall/GET_UNIQUE_ID'];
  if (!isShowSGMType && !IsRegistered) {
    sessionStorage.setItem(Constants.SessionStorageKeys.AccountConfirmed, true);
    let redirectUrl = await getRedirectUrlForNotRegisteredUser();
    if (uniqueId) {
      return {
        name: redirectUrl,
        params: { uniqueId }
      };
    }
    if (confId) {
      return `/${redirectUrl}?show=${showId}&confId=${confId}`;
    }
    return `/${redirectUrl}?show=${showId}`;
  } else {
    if (isShowSGM) {
      const Disclaimers = getDisclaimerData();
      if (Disclaimers && !!Disclaimers.length) {
        return uniqueId ? {
          name: 'disclaimer-new',
          params: { uniqueId }
        } : `/disclaimer?show=${showId}`;
      }
    }
    if (uniqueId) {
      return {
        name: 'call-confirmation-new',
        params: { uniqueId }
      };
    }
    if (confId) {
      return `/call-confirmation?show=${showId}&confId=${confId}`;
    }
    return `/call-confirmation?show=${showId}`;
  }
}

async function handleRedirection() {
  const uniqueId = store.getters['conferenceCall/GET_UNIQUE_ID'];
  const showId = uniqueId ? store.state.conferenceCall.showId : getUrlQueryParam();
  const confId = uniqueId ? store.state.conferenceCall.confId : getAllUrlQueryParam('confId');
  const isUserMissingInformation = getMissingInfoStatus();
  if (isUserMissingInformation.IsMissingFields) {
    sessionStorage.setItem(Constants.SessionStorageKeys.AccountConfirmed, true);
    if (confId) {
      try {
        /**
         * Check For Missing Information
         */
        await getConferenceCallAndBrandingInfo(showId, confId);
      } catch (e) {
        console.log(e);
      }
      const brandingData = getBrandingInfo();
      let shouldSkipMissingInfoPage = false;
      if (brandingData && brandingData.RegistrationFields) {
        shouldSkipMissingInfoPage = skipMissingInfoPage({ RegistrationFields: brandingData.RegistrationFields, MissingInformation: isUserMissingInformation });
      }
      if (!shouldSkipMissingInfoPage) {
        return uniqueId ? {
          name: 'register-new',
          params: { uniqueId }
        } : `/register?show=${showId}&confId=${confId}`;
      }
    } else {
      return uniqueId ? {
        name: 'register-new',
        params: { uniqueId }
      } : `/register?show=${showId}`;
    }
  }
  await onRouteInitialize();

  /**
   * redirect to the appropriate page based on the user registration.
   */
  return getRedirectionResult(confId, showId);
}

export async function getRedirectUrlForNotRegisteredUser() {
  const { AskForPublicPrivate } = getConferenceData();
  const barndingData = getBrandingInfo();
  let userIsPresenter = isUserPresenter() ? isUserPresenter() : JSON.parse(sessionStorage.getItem(Constants.SessionStorageKeys.IsPresenter));
  var index = -1;
  if(barndingData && barndingData.RegistrationFields){
    index = barndingData.RegistrationFields.findIndex((val) => {
      return val.Name!=='AccountType' && val.Name!=='CompanyRole' && val.Name !== 'PhoneNumber' && !val.IsDeleted;
    });
  }
  var additionalInstructionsPresent = -1;
  if(barndingData && barndingData.CustomMessages){
    additionalInstructionsPresent = barndingData.CustomMessages.findIndex((val) => {
      return val.Key==='AdditionalInstructions' && val.Value!=='';
    });
  }

  const uniqueId = store.getters['conferenceCall/GET_UNIQUE_ID'];

  if((AskForPublicPrivate && !userIsPresenter) || index!==-1 || additionalInstructionsPresent!==-1){
      return uniqueId ? 'supplemental-register-new' : 'supplemental-register';
    } else {
      if (AskForPublicPrivate && userIsPresenter) {
        sessionStorage.setItem(Constants.SessionStorageKeys.IsPublicParticipant, false);
      }
      const Disclaimers = getDisclaimerData();
  
      if (Disclaimers && !!Disclaimers.length) {
        return uniqueId ? 'disclaimer-new' : 'disclaimer';
      } else {
        await store.dispatch('conferenceCall/registerForConferenceCall');
        return uniqueId ? 'call-confirmation-new' : 'call-confirmation';
      }
    }
}

export async function getRedirectForCallConfirmation(showId, confId, email) {
  //Check for participant registeration
  if (!isSGMType() && !Object.keys(getRegisteredUserForCall()).length) {
    const uniqueId = store.getters['conferenceCall/GET_UNIQUE_ID'];
    if (uniqueId) {
      return {
        name: 'login-new',
        params: { uniqueId }
      };
    }
    if (confId) {
      return `/login?show=${showId}&confId=${confId}&email=${email}`;
    }
    return `/login?show=${showId}`;
  }
  // Check For Slides + conference shows
  else if (isSlidePlusConfShow()) {
    if(isEventViewerEnabled() || getPublicParticipantAccessRevoked() || !(getParticipantAccessRevoked())){
    redirectToPresentationViewer(showId);
    return false;
    }
  }
  else if(isSlidePlusLiveVideo() || isSimuLiveVideo()) {
    if (getPublicParticipantAccessRevoked() || !(getParticipantAccessRevoked())) {
      redirectToPresentationViewer(showId);
      return false;
    }
  }
  else if(isSGM()) {
    redirectToPresentationViewer(showId);
    return false;
  }
  else if (isSGMOperatorAssisted()) {
    await redirectToZoom(showId);
    return false;
  }
  else if(isConfOnlyShow()) {
    const { PresId } = getConferenceData();
    const opt = {
      presId: PresId,
      showId,
      confId,
    };
    store.dispatch('service/set_loader', true);
    var res = await getPresentationRouteUrl(opt);
    if (res.data.DestinationPath) {
      redirectToPresentationViewer(showId);
      return false;
    } else {
      store.dispatch('service/set_loader', false);
    }
  }
}

export function redirectToPresentationViewer(showId) {
  //Showing loader while redirecting
  store.dispatch('service/set_loader', true);

  const { PresId, Id } = getConferenceData();
  const logId = store.getters['presentation/GET_LOG_ID'];

  const presentationPath = Constants.Urls.presentationUrl.replace('{email}', getUserEmailAddress())
    .replace('{presId}', PresId)
    .replace('{logId}', logId)
    .replace('{confId}', Id)
    .replace('{showId}', showId);

  window.location.href = window.location.origin + presentationPath;
}

export async function redirectToZoom(showId) {
  //Showing loader while redirecting
  store.dispatch('service/set_loader', true);
  const { PresId, MeetingId } = getConferenceData();
  const { CoreId } = store.getters['login/GET_LOGGED_IN_USER'];
  var sgmJoinLink = await getSGMMeetingJoinLink(PresId, MeetingId, showId, CoreId);
  window.location.href =  sgmJoinLink.data.zoomJoinUrl;
}

export async function createConferenceCallGuard(to, from, next, options = {}, getRedirect = getRedirectBasedOnConferenceCallExists) {
  const { showId, confId, shouldRedirect = true } = options;
  const show = showId || to.query.show;
  const conf = confId || to.query.confId;

  try {
    const nextRoute = await getRedirect(show, conf);

    if (nextRoute && shouldRedirect) {
      next(nextRoute);
      return;
    }

    next();
  } catch (error) {
    next('/site-not-available');
  }
}
